import styled from '@emotion/styled';
import { Icon, RichTooltip, Typography } from '@innovamat/glimmer-components';
import { useTranslation } from 'react-i18next';
import type {
  AppletsOfTheWeek,
  AppletsOfTheWeekDate,
} from '../../classrooms-management/modules/applets-of-the-week/applets-of-the-week';
import WeekInformation from './week-information';

const TextWrapper = styled.div`
  color: ${({ theme }) => theme.tokens.color.alias.cm.text.text.value};
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const IconContainer = styled.div`
  display: flex;
  width: 12px;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

const StyledRichTooltip = styled(RichTooltip)`
  align-self: flex-start;
`;

const StyledIcon = styled(Icon)`
  cursor: pointer;
`;

const SubtitleWrapper = styled.div`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
  display: flex;
  gap: 0.3rem;
  align-items: baseline;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

type Props = {
  title: string;
  subtitle: string;
  weekToShow: AppletsOfTheWeek['weekToShow'];
  startDate: AppletsOfTheWeekDate;
  endDate: AppletsOfTheWeekDate;
  onClickMoreInfo: () => void;
};

const TextInformation = ({
  title,
  subtitle,
  weekToShow,
  startDate,
  endDate,
  onClickMoreInfo,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <TextWrapper>
      <TitleWrapper>
        <Typography.H4>{title}</Typography.H4>
        <StyledRichTooltip
          buttonText={t('homeWeeklyPractice.moreInfo')}
          description={t('homeWeeklyPractice.infoToggle')}
          onButtonClick={onClickMoreInfo}
          trigger="click"
          delay={[0, 0]}
        >
          <IconContainer>
            <StyledIcon
              bgColor="black"
              icon="InfoIcon"
              iconColor="white"
              size="S"
            />
          </IconContainer>
        </StyledRichTooltip>
      </TitleWrapper>
      <SubtitleWrapper>
        <Typography.Body2>{subtitle}</Typography.Body2>
        <WeekInformation
          weekToShow={weekToShow}
          startDate={startDate}
          endDate={endDate}
        />
      </SubtitleWrapper>
    </TextWrapper>
  );
};

export default TextInformation;
